import React, { useEffect, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import './CookieUI.css'; // Import the CSS file
import App from '../App';
import { Link } from 'react-router-dom';

const CookieUI = () => {

    const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Set a timeout to show the consent modal after 1 second
    const timer = setTimeout(() => {
      setShowConsent(true);
    }, 1000); // 1000 milliseconds = 1 second

    // Clean up the timer if component unmounts
    return () => clearTimeout(timer);
  }, []); // Empty dependency array means this runs once on mount

  if (!showConsent) {
    return <App/>; // Don't render anything until the delay is over
  }
  return (
    <div className="cookie-modal">
      <CookieConsent 
        location="bottom" // Prevents default bottom positioning
        buttonText="Accept All"
        declineButtonText="Reject All"
        enableDeclineButton
        cookieName="myAwesomeCookieName2"
        containerClasses="cookie-container"
        buttonWrapperClasses="cookie-buttons"
        expires={5}
        overlay={true}
      >
        <h2 className="cookie-title">We Care About Privacy</h2>
        <p className="cookie-text">
          We use cookies to enhance your browsing experience, serve personalized ads or 
          content, and analyze our traffic. By clicking "Accept All", you consent to 
          our use of cookies.{" "}
          <b className="cookie-link">
            <Link to="/cookies">
             Cookie Policy
            </Link>
           
          </b>
        </p>
        {/* <button 
          className="customize-button" 
          onClick={() => {
            // Add your customization logic here
            console.log("Customize clicked");
          }}
        >
          Customize
        </button> */}
      </CookieConsent>
    </div>
  );
};

export default CookieUI;